export enum AppToastTypes {
    Success = 'SUCCESS', 
    Failure = 'FAILURE', 
}

export enum AD_Invoice_Selector {
    LastTwenty = '20', 
    LastFifty = '50', 
    LastOneHundred = "100", 
    LastTwoHundredFifty = "250", 
    Last30 = "Last 30",
    Last60 = "Last 60", 
    LastMonth = "Last Month",
    YTD = "YTD",
    LastYear = "Last Year"
}

export enum MetricType {
    Average  = "Average", 
    Count = "Count",
    Money = "Money", 
    Percent = "Percent"
}